import { baseApi, client } from 'api/baseApi.ts';
import GetCanvasResponse from 'api/response/GetCanvasResponse.ts';
import GetListCanvasResponse from 'api/response/GetListCanvasResponse.ts';
import { APIConfigData } from 'core/config/APIConfigData';

export const canvasListEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		listCanvas: builder.query({
			queryFn: async ({
				page = 1,
				pageSize = APIConfigData.CANVAS_PAGE_SIZE,
			}: { page?: number; pageSize?: number } = {}) => {
				const request = { page, page_size: pageSize };
				const response = await client.canvas.list(request);
				return { data: new GetListCanvasResponse(response.data).formatListCanvasData() };
			},
		}),
		getCanvas: builder.query({
			queryFn: async ({ canvasId }: { canvasId?: string }) => {
				const response = await client.canvas.details(canvasId);
				return { data: new GetCanvasResponse(response.data).formatCanvasDetailsData() };
			},
		}),
		updateCanvas: builder.mutation({
			queryFn: async ({ canvasId, request }) => {
				const response = await client.canvas.update(canvasId, request);
				return { data: new GetCanvasResponse(response.data).formatCanvasDetailsData() };
			},
		}),

		createCanvas: builder.mutation({
			queryFn: async () => {
				const response = await client.canvas.create();
				return { data: new GetCanvasResponse(response.data).formatCanvasDetailsData() };
			},
		}),

		deleteCanvas: builder.mutation({
			queryFn: async ({ canvasId }) => {
				const response = await client.canvas.archive(canvasId);
				return { data: new GetCanvasResponse(response.data).formatCanvasDetailsData() };
			},
		}),
	}),
});
